module.exports = __webpack_public_path__ + "img/12_BC13_sleep_around.b4da60c3.jpg";